import { createAPIMethod } from 'utils/generic';
import { type ResponseFavoriteOfferData } from './model.js';

export type FavoriteOffers = Record<number, boolean>;

export function normalizeFavoriteOffersData(offers: ResponseFavoriteOfferData[]) {
	return offers.reduce((acc: FavoriteOffers, offer) => {
		acc[Number(offer.advert_id)] = true;
		return acc;
	}, {});
}

export async function getFavoriteOffers(headers?: HeadersInit) {
	try {
		return await createAPIMethod<object, FavoriteOffers>({
			path: `/items/favorites/ids`,
			method: 'GET',
			normalize: ({ results }) => normalizeFavoriteOffersData(results),
			headers,
		})();
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	} catch (_e) {
		return {} as FavoriteOffers;
	}
}

export async function favoriteOffer(offerId: number, headers?: HeadersInit) {
	return createAPIMethod<{ advert_id: number }, void>({
		path: `/items/favorites`,
		method: 'POST',
		skipResponseParsing: true,
		headers,
	})({ advert_id: offerId });
}

export async function unfavoriteOffer(offerId: number, headers?: HeadersInit) {
	return createAPIMethod<{ advert_id: string }, void>({
		path: `/items/favorites/${offerId}`,
		method: 'DELETE',
		skipResponseParsing: true,
		headers,
	})();
}
